(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hospitalization', {
            parent: 'entity',
            url: '/hospitalization?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.hospitalization.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization/hospitalizations.html',
                    controller: 'HospitalizationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalization');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hospitalization-detail', {
            parent: 'entity',
            url: '/hospitalization/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.hospitalization.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization/hospitalization-detail.html',
                    controller: 'HospitalizationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalization');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Hospitalization', function($stateParams, Hospitalization) {
                    return Hospitalization.get({id : $stateParams.id});
                }]
            }
        })
        .state('hospitalization.new', {
            parent: 'hospitalization',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization/hospitalization-dialog.html',
                    controller: 'HospitalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                pagientAge: null,
                                notes: null,
                                dateIssue: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hospitalization', null, { reload: true });
                }, function() {
                    $state.go('hospitalization');
                });
            }]
        })
        .state('hospitalization.edit', {
            parent: 'hospitalization',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization/hospitalization-dialog.html',
                    controller: 'HospitalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Hospitalization', function(Hospitalization) {
                            return Hospitalization.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hospitalization.delete', {
            parent: 'hospitalization',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization/hospitalization-delete-dialog.html',
                    controller: 'HospitalizationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Hospitalization', function(Hospitalization) {
                            return Hospitalization.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
